import { Box, IconButton, Stack, Typography } from "@mui/material";
import React from "react";
import Chips from "../../components/Chips";
import ApiService from "./../../services/api-service";
import notifier from "./../../components/Notifier";
import Loader from "./../../components/Loader";
import NoData from "./../../components/Nodata";
import MusicCard from "../../components/MusicCard";
import { Images } from "../../assets/common";
import LockIcon from "@mui/icons-material/Lock";

import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { useHistory, useLocation, useParams } from "react-router-dom";
import {
  getErrorString,
  getUserId,
  isOwner,
  fullName,
} from "./../../constants/function";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import DropMenu from "../../components/DropMenu";
import { useDispatch } from "react-redux";
import { addSongAction, addSongsAction } from "./../../action/songs";
import { useTranslation } from "react-i18next";
export default function UnlockedAssets() {
  const { t } = useTranslation("common");
  const [selectedId, setSelectedId] = React.useState(null);
  const dispatch = useDispatch();
  const [show, setShow] = React.useState(false);
  const location = useLocation();
  const history = useHistory();
  const [activeTab, setActiveTab] = React.useState(
    location.pathname === "/app/UnlockedAssets/Music" ? 0 : 1
  );
  const [loading, setLoading] = React.useState(false);
  const [nft, setNft] = React.useState([]);
  const [playlistNft, setPlaylistNft] = React.useState([]);
  const getUnlockedAssets = async (tab) => {
    try {
      setLoading(true);
      const response =
        tab === 0
          ? await ApiService.UNLOCKED_ASSETS({
              type: "music",
              pageSize: 50,
              pageNo: 1,
            })
          : await ApiService.UNLOCKED_ASSETS({
              type: "playlist",
              pageSize: 50,
              pageNo: 1,
            });
      setNft([...response["result"]]);
      //   else setPlaylistNft([...response["result"]]);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      notifier.error(getErrorString(error));
    }
  };

  React.useEffect(() => {
    setSelectedId(null);
    getUnlockedAssets(activeTab);
  }, [activeTab]);
  const addSong = async (nft, isPlaylist) => {
    if (!isPlaylist) dispatch(addSongAction(nft));
    else if (isPlaylist) {
      history.push(`/app/Music/${nft["_id"]}`);
    }
  };
  const getPlayListMusic = async (_id) => {
    try {
      setLoading(true);
      const response = await ApiService.PLAYLIST_DETAIL({
        _id: _id,
        pageNo: 1,
        pageSize: 16,
      });

      setLoading(false);

      return response["result"]["music"];
    } catch (error) {
      setLoading(false);
      if (getErrorString(error) !== "Playlist has no music")
        notifier.error(getErrorString(error));
      return [];
    }
  };
  return (
    <Box className="__assets_container__">
      <Stack direction="row" gap="20px">
        <Chips
          label={t("assetPopup.section1")}
          activeTab={activeTab}
          index={0}
          handleClick={(e) => {
            history.push("/app/UnlockedAssets/Music");
            setActiveTab(e);
          }}
        />
        <Chips
          label={t("assetPopup.section2")}
          activeTab={activeTab}
          index={1}
          handleClick={(e) => {
            history.push("/app/UnlockedAssets/Playlist");
            setActiveTab(e);
          }}
        />
      </Stack>

      <Box
        sx={{
          position: "relative",
          display: "flex",
          gap: "20px",
          flexWrap: "wrap",
          marginTop: "20px",
        }}
      >
        {nft.length > 0 ? (
          nft.map((nft, index) => (
            <MusicCard
              platform={nft.platform}
              key={index}
              music={nft}
              isMusic={activeTab === 0 && !nft["nftId"] ? true : false}
              isNft={activeTab === 0 && nft["nftId"] ? true : false}
              isPlaylistNft={activeTab === 1 ? true : false}
              actions={
                nft["nftId"]
                  ? [{ key: "m8", action: t("dropMenu.m8") }]
                  : [
                      activeTab === 0
                        ? { key: "m1", action: t("dropMenu.m1") }
                        : { key: "m32", action: t("dropMenu.m32") },
                    ]
              }
              toggleMenu={() => {
                if (
                  nft["private"] &&
                  !isOwner(nft["owner"] ? nft["owner"]["email"] : "")
                ) {
                  notifier.info(t("info"));
                } else if (
                  location.pathname.includes("/app/UnlockedAssets") &&
                  activeTab === 0 &&
                  !nft["nftId"]
                ) {
                  history.push(`/app/SongDetails/${nft["_id"]}`);
                } else if (
                  location.pathname.includes("/app/UnlockedAssets") &&
                  activeTab === 1 &&
                  !nft["nftId"]
                ) {
                  history.push(`/app/Music/${nft["_id"]}`);
                } else {
                  history.push(
                    `/app/${
                      activeTab === 0 ? "NftDetail" : "PlaylistNftDetail"
                    }/${nft["nft"] ? nft["nft"]["_id"] : nft["nftId"]}`
                  );
                }
              }}
            />

            // <Box key={index} className="__asset_col">
            //   <Box sx={{ position: "relative" }}>
            //     <img
            //       className="__assets__"
            //       src={
            //         nft["thumbnailImg"]
            //           ? nft["thumbnailImg"]["filePath"]
            //           : nft["userDetails"]
            //           ? nft["userDetails"]["profileImg"]["filePath"]
            //           : nft["music"]["thumbnailImg"]
            //           ? nft["music"]["thumbnailImg"]["filePath"]
            //           : Images.dummy
            //       }
            //       onClick={() => addSong(nft, activeTab === 0 ? false : true)}
            //       alt="Image"
            //     />
            //     <Box
            //       className="__asset_hover"
            //       sx={{
            //         position: "absolute",
            //       }}
            //     >
            //       <IconButton
            //         onClick={() => {
            //           if (
            //             nft["private"] &&
            //             !isOwner(nft["owner"] ? nft["owner"]["email"] : "")
            //           ) {
            //             notifier.info(
            //               "Subscribe artist to access private assets"
            //             );
            //           } else if (
            //             location.pathname.includes("/app/UnlockedAssets") &&
            //             activeTab === 0 &&
            //             !nft["nftId"]
            //           ) {
            //             history.push(`/app/SongDetails/${nft["_id"]}`);
            //           } else if (
            //             location.pathname.includes("/app/UnlockedAssets") &&
            //             activeTab === 1 &&
            //             !nft["nftId"]
            //           ) {
            //             history.push(`/app/Music/${nft["_id"]}`);
            //           } else {
            //             history.push(
            //               `/app/${nft["nft"] ? "BuyInfo" : "SellAuction"}/${
            //                 nft["nft"] ? nft["nft"]["_id"] : nft["nftId"]
            //               }`
            //             );
            //           }
            //         }}
            //       >
            //         <img src={Images.play} alt="play" />
            //       </IconButton>
            //       <IconButton
            //         className="__more_hover"
            //         onClick={(e) => {
            //           e.stopPropagation();
            //           setSelectedId(nft["_id"]);
            //           setShow(!show);
            //         }}
            //       >
            //         <MoreVertIcon />
            //       </IconButton>
            //       {nft["_id"] === selectedId ? (
            //         <DropMenu
            //           actions={["View NFT details"]}
            //           toggleMenu={() => {
            //             if (
            //               nft["private"] &&
            //               !isOwner(nft["owner"] ? nft["owner"]["email"] : "")
            //             ) {
            //               notifier.info(
            //                 "Subscribe artist to access private assets"
            //               );
            //             } else if (
            //               location.pathname.includes("/app/UnlockedAssets") &&
            //               activeTab === 0 &&
            //               !nft["nftId"]
            //             ) {
            //               history.push(`/app/SongDetails/${nft["_id"]}`);
            //             } else if (
            //               location.pathname.includes("/app/UnlockedAssets") &&
            //               activeTab === 1 &&
            //               !nft["nftId"]
            //             ) {
            //               history.push(`/app/Music/${nft["_id"]}`);
            //             } else {
            //               history.push(
            //                 `/app/${
            //                   activeTab === 0
            //                     ? "BuyInfo"
            //                     : "SellAuctionPlayList"
            //                 }/${nft["nft"] ? nft["nft"]["_id"] : nft["nftId"]}`
            //               );
            //             }
            //           }}
            //         />
            //       ) : null}
            //     </Box>
            //   </Box>
            //   <Stack direction="row" justifyContent="space-between">
            //     <Box>
            //       <Typography className="fs-16">{nft["title"]}</Typography>
            //       <Typography className="fs-14 fade-text-60">
            //         {fullName(nft["userDetails"])}
            //       </Typography>
            //     </Box>
            //     {nft["private"] ? (
            //       <LockIcon
            //         sx={{ width: "16px", height: "16px", padding: "3px" }}
            //         className="__small_icon"
            //       />
            //     ) : null}
            //   </Stack>
            // </Box>
          ))
        ) : (
          <NoData lable={t("noData.noData")} />
        )}
      </Box>
      {loading ? <Loader /> : null}
      {/* {nft.length === 0 ? <NoData label="No data" /> : null} */}
    </Box>
  );
}
